/* eslint-disable */
export default {
  name: 'MapGeocode',
  methods: {
    geocodeLatLng (latlng) {
      this.geocoder.geocode({'location': latlng}, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            return results[0].formatted_address
          } else {
            throw new Error('Endereço não encontrado')
          }
        } else {
          throw new Error('Falha no geocoder: ' + status)
        }
      })
    },

    geocodeAddress (address) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode({'address': address}, function (results, status) {
          if (status === 'OK') {
            resolve(results[0].geometry.location)
          } else {
            reject('Endereço não encontrado: ' + status)
          }
        })
      })

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/map/mixins/Geocode.js